import styled from "@emotion/styled";
import TemplateHeader from '../../../components/templates/TemplateHeader'
import TemplateNavigation from '../../../components/templates/TemplateNavigation'
import TemplateHero from '../../../components/templates/TemplateHero'
import TemplateButton from '../../../components/templates/TemplateButton'

const Layout = styled.section``;

Layout.Img = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

Layout.ImgCover = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(59, 71, 102, 0.50);
`
Layout.Container = styled.div`
  height: 100vh;
  overflow: hidden;
`;

Layout.Content = styled(TemplateHero)`
  position: relative;
  margin: 0 auto;
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 100px);
`;

Layout.PreHeader = styled.div`
  height: 60px;
  background: #3b4766;
  color: #FFFFFF;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

Layout.Header = styled(TemplateHeader)`
  height: 75px;
  background: #FFFFFF;
  color: ${({ theme }) => theme.palette.primary.main};
`;

Layout.Logo = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`

Layout.LogoImage = styled.img`
  height: 70px;
  justify-self: flex-start;
`

Layout.LogoText = styled.span`
  font-size: 22px;
  font-weight: 700;
`
Layout.HeaderContent = styled.div`
  max-width: 1024px;
  margin: 0 auto;
  height: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 0 30px;
`;

Layout.Navigation = styled(TemplateNavigation)``

Layout.Title = styled.h1`
  font-size: 22px;
  font-weight: bold;
`;

Layout.HeroTitle = styled.h2`
  font-size: 72px;
  z-index: 2;
  color: white;
  text-transform: uppercase;
  text-align: center;
  font-weight: bold;
  margin: 160px 0;
`;


Layout.IconButton = styled.div`
  padding: 8px;
  border: 3px solid ${({theme}) => theme.palette.text.primary};
`;

Layout.CTA = styled(TemplateButton)`
  z-index: 2;
  height: 56px;
  padding: 6px 40px;
  font-weight: bold;
  font-size: 20px;
  width: 218px;
`;

export default Layout;
